import {AmsListItemBase} from './AmsListItemBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class AmsMasterListItem extends AmsListItemBase {
    id: string = '';
    amsStatus: string = '';
    userId: string = '';
    block: boolean|null = null;
    branch: string = '';
    manifestSeq: string = '';
    mblNo: string = '';
    vesselName: string = '';
    voyage: string = '';
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    loadingPort: string = '';
    finalDest: string = '';
    loadEtd: string | null = null;
    fromLoadEtd: string | null = null;
    toLoadEtd: string | null = null;
    onBoard: string | null = null;
    fromOnBoard: string | null = null;
    toOnBoard: string | null = null;
    discharge: string = '';
    notify: string = '';
    containerNo: string = '';
    amsVoyageId: string = '';
    expr1: number|null = null;
    amsUserId: number|null = null;
    amsGroupId: number|null = null;
    firstETA: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true, filterable: false }),
        XCol.Create({ col: 1, text: 'AMS ID', width: 80, dataIndex: 'id', align: XCol.XAlignType.Right, hiddenInColumnSetup: true}),
        XCol.Create({ col: 2, text: 'S', width: 40, dataIndex: 'amsStatus', align: XCol.XAlignType.Center, hiddenInColumnSetup: true}),
        XCol.Create({ col: 3, text: 'User', width: 100, dataIndex: 'userId'}),
        XCol.Create({ col: 4, text: 'Block', width:40, dataIndex: 'block', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 5, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'Manifest #', width: 100, dataIndex: 'manifestSeq'}),
        XCol.Create({ col: 7, text: 'MBL #', width: 100, dataIndex: 'mblNo', defaultColumnFocus : true}),
        XCol.Create({ col: 8, text: 'Vessel Name', width: 120, dataIndex: 'vesselName'}),
        XCol.Create({ col: 9, text: 'Voyage #', width: 80, dataIndex: 'voyage'}),
        XCol.Create({ col: 10, text: 'Org. Load ETD', width: 75, dataIndex: 'onBoard', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 11, text: 'M. Vessel ETD', width: 75, dataIndex: 'loadEtd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 13, text: 'Loading Port', width: 120, dataIndex: 'loadingPort'}),
        XCol.Create({ col: 14, text: 'Discharge Port', width: 120, dataIndex: 'discharge'}),
        XCol.Create({ col: 15, text: 'Final Destination', width: 120, dataIndex: 'finalDest'}),
        XCol.Create({ col: 16, text: 'Notify', width: 80, dataIndex: 'notify'}),
        XCol.Create({ col: 17, text: 'Container #', width: 90, dataIndex: 'containerNo'})
        ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: AmsMasterListItem.prototype.id, orderByAscending: false };

    public static formatData(data: AmsMasterListItem[]) {
        return data.map((d: AmsMasterListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        onBoard: {from: 'fromOnBoard', to: 'toOnBoard'},
        loadEtd: {from: 'fromLoadEtd', to: 'toLoadEtd'},
        eta: {from: 'fromEta', to: 'toEta'},
    }
}
